export default __webpack_public_path__ + "static/media/opel_car.a1d81e3d.jpg";